<script>
  //// Exports
  import Button from "lib/components/Button.svelte";

  export let addActivityClicked;
  export let expandActivityClicked;
  export let removeActivityClicked;
  export let isActivityNode = false;
  export let parentNode;
  let app = "";
  let title = "";
  let icon = "";

  export let position = { x: 0, y: 0 };
  export let visible = false;
</script>

<div
  class="menu_wrapper"
  style="display:{visible ? 'flex' : 'none'}; position:fixed; top:{position.y -
    15}px; left:{position.x + 50}px;"
>
  <div class="menu_heading">
    {#if icon && icon !== "..."}
      <div class="icon">
        <img src="/api/analysis/automationIcon?application={icon}" alt={icon} />
      </div>
    {/if}
    <div class="app_information">
      <div class="app_name bold">{app}</div>
      <div class="node_title">{title}</div>
    </div>
  </div>
  <div class="main">
    <!-- @Adrian die ganzen In- und Out-Infos erstmal ausgeblendet, solange diese Informationen nicht greifbar sind -->
    <!-- <div class="mainsection">
      <div class="mainsection_heading bold">Incoming Tasks</div>
      <div class="pagination">
        <WorkFlowExplorerDropdownMenuPagination
          app={selectedNodeInApp}
          title={selectedNodeInTitle}
          selectedNode={selectedNodeIn}
          disablePrev={selectedNodeIn < 2}
          disableNext={selectedNodeIn === totalNodesIn}
        />
      </div>
      <div class="pagination_info">
        <div class="count">{selectedNodeIn}/{totalNodesIn}</div>
        <div class="info">
          <div class="bold">In:</div>
          <div>{selectedNodesInInteractions} / {selectedNodesInShare}%</div>
        </div>
      </div>
    </div>
    <div class="mainsection">
      <div class="mainsection_heading bold">Outgoing Tasks</div>
      <div class="pagination">
        <WorkFlowExplorerDropdownMenuPagination
          app={selectedNodeOutApp}
          title={selectedNodeOutTitle}
          selectedNode={selectedNodeOut}
          disablePrev={selectedNodeOut < 2}
          disableNext={selectedNodeOut === totalNodesOut}
        />
      </div>
      <div class="pagination_info">
        <div class="count">{selectedNodeOut}/{totalNodesOut}</div>
        <div class="info">
          <div class="bold">In:</div>
          <div>{selectedNodesOutInteractions} / {selectedNodesOutShare}%</div>
        </div>
      </div>
    </div> -->

    <!-- <div class="mainsection">
      <div class="mainsection_heading bold">Task Relevance Score</div>
      <div class="score_wrapper">
        <div class="total_in total">
          <div class="bold">Total In</div>
          <div class="div">{totalInteractionsIn}</div>
        </div>
        <div class="arrow">
          <img src="/img/assistant/icons/arrow_right_dark.svg" alt="arrow" />
        </div>
        <div class="total_score">
          <ProgressStatus share={totalScore} unit={false} value="Score" />
        </div>
        <div class="arrow">
          <img src="/img/assistant/icons/arrow_right_dark.svg" alt="arrow" />
        </div>
        <div class="total_out">
          <div class="total_in total">
            <div class="bold">Total Out</div>
            <div class="div">{totalInteractionsOut}</div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  {#if isActivityNode}
    <div class="button_wrapper">
      <Button
        enlarge={true}
        variant="secondary"
        text={parentNode && parentNode !== "undefined"
          ? "Change Activity"
          : "Add to Activity"}
        on:click={() => {
          addActivityClicked();
          visible = false;
        }}
      />
      <!-- <Button
        enlarge={true}
        variant="secondary"
        text="More Details"
        on:click={()=>{moreDetailsClicked(); visible = false;}}
      /> -->
      {#if parentNode && parentNode !== "undefined"}
        <Button
          enlarge={true}
          variant="secondary"
          text="Remove from Activity"
          on:click={() => {
            removeActivityClicked();
            visible = false;
          }}
        />
      {/if}
    </div>
  {:else}
    <div class="button_wrapper">
      <Button
        enlarge={true}
        variant="secondary"
        text="Expand Activity"
        on:click={() => {
          expandActivityClicked();
          visible = false;
        }}
      />
      <!-- <Button
        enlarge={true}
        variant="secondary"
        text="More Details"
        disabled={true}
        on:click={()=>{moreDetailsClicked(); visible = false;}}
      /> -->
    </div>
  {/if}
</div>

<style>
  /*
  .score_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }
 
  .total_score {
    height: 5rem;
  }

  .pagination_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
  }

  .info {
    display: flex;
    gap: 0.5rem;
  }

*/
  .menu_wrapper {
    flex-direction: column;
    border-radius: 0.5rem;
    background-color: white;
    z-index: 9999;
    box-shadow: 0 0 0.125rem 0.125rem #1c1c2025;
  }

  /* .mainsection {
    border-bottom: 1px solid #d9d9d9;
    padding: 1rem 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  } */

  .menu_heading {
    background-color: var(--pax-black);
    color: white;
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
    display: flex;
    gap: 0.5rem;
    display: flex;
    align-items: center;
    padding: 1rem;
  }

  .main {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
  }

  .button_wrapper {
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .icon {
    display: flex;
    height: 2rem;
    width: 2rem;
    justify-content: flex-start;
    align-items: center;
  }

  .button_wrapper {
    display: flex;
    gap: 0.5rem;
  }
</style>
